// extracted by mini-css-extract-plugin
export var infoBox = "style-module--infoBox--b5113";
export var infoBox__close = "style-module--infoBox__close--b8c44";
export var infoBox__container = "style-module--infoBox__container--76109";
export var infoBox__logo = "style-module--infoBox__logo--55cf8";
export var infoBox__main = "style-module--infoBox__main--9247f";
export var infoBox__rightFloat = "style-module--infoBox__rightFloat--1c7fd";
export var infoBox__text = "style-module--infoBox__text--a43c4";